module.exports = __webpack_public_path__ + "img/image43.d9997c30.png";